import { MbButtons, MbButton, TestimonialSlider } from "./clientMasterBlocks";
import { BlockRenderer } from ".";

// const CounterUp = dynamic(() => import("@litonarefin/components/MbBlocks/CounterUp"));

export const masterBlocks = {
  ["master-blocks/testimonial-slider"]: (block) => (
    <TestimonialSlider key={block?.id} attributes={block.attributes} />
  ),
  ["master-blocks/buttons"]: (block) => (
    <MbButtons key={block?.id} attributes={block?.attributes}>
      <BlockRenderer blocks={block.innerBlocks} />
    </MbButtons>
  ),

  ["master-blocks/button-child"]: (block) => (
    <MbButton key={block?.id} attributes={block?.attributes} />
  ),
};
